import React from "react";
import { Outlet } from "react-router-dom";
import HeaderComponent from "./HeaderComponent";

function Layout() {
  return (
    <div>
      <HeaderComponent />
      <Outlet />
    </div>
  );
}

export default Layout;
